import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aec92fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Increased Drop Rates!", -1))
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "grow" }
const _hoisted_5 = { class: "five-star star-text" }
const _hoisted_6 = { class: "star-holder" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Percentage of 5-Star Item Drops: 50.000% ")
const _hoisted_8 = { class: "character-profile" }
const _hoisted_9 = { class: "grow" }
const _hoisted_10 = { class: "four-star star-text" }
const _hoisted_11 = { class: "star-holder" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Percentage of 4-Star Item Drops: 50.000% ")
const _hoisted_13 = { class: "character-profile" }

import { ElementDatabase, ItemDatabase } from "@/state/Gacha";
import { Banner, Item } from "@/types";
import CharacterProfile from "./CharacterProfile.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as { banner: Banner }



const featured5Stars = computed(() =>
  props.banner.featuredDrops
    .filter((c) => ItemDatabase[c].rarity === 5)
    .map((c) => ItemDatabase[c])
);

const featured4Stars = computed(() =>
  props.banner.featuredDrops
    .filter((c) => ItemDatabase[c].rarity === 4)
    .map((c) => ItemDatabase[c])
);

const getCharacterElementStyle = (character: Item) => {
  return {
    color: ElementDatabase[character.element]?.color,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createElementVNode("span", {
                key: index,
                class: "star-img"
              })
            }), 64))
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featured5Stars), (c, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                style: _normalizeStyle(getCharacterElementStyle(c))
              }, _toDisplayString(c.name), 5))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featured5Stars), (c, i) => {
              return (_openBlock(), _createBlock(CharacterProfile, {
                key: i,
                character: c
              }, null, 8, ["character"]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
              return _createElementVNode("span", {
                key: index,
                class: "star-img"
              })
            }), 64))
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featured4Stars), (c, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: i,
                style: _normalizeStyle(getCharacterElementStyle(c))
              }, _toDisplayString(c.name), 5))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featured4Stars), (c, i) => {
              return (_openBlock(), _createBlock(CharacterProfile, {
                key: i,
                character: c
              }, null, 8, ["character"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})